// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__32yCg","listContainer":"List_listContainer__4Z1tA"};